import { Component, OnInit } from '@angular/core';
import {MdDialog,MdSnackBar} from '@angular/material';
import { ListingService } from '../../listing.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-email-sent-to',
  templateUrl: './email-sent-to.component.html',
  styleUrls: ['./email-sent-to.component.css','../../admin.css', '../../../app.component.css'],
  providers: [ListingService]
})
export class EmailSentToComponent implements OnInit {
  historyId: any;
  nameArray: any;
  errorMessage: any;
  spinner: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,private ListingService: ListingService,private snackBar: MdSnackBar) { }

  ngOnInit() {
    this.getEmailName();
  }

  getEmailName(){
    this.spinner = true;
    this.ListingService.getEmailName({historyId:this.historyId}).subscribe(
     response => {
      this.spinner = false;
      this.nameArray = response;
     },
     error => {
      this.spinner = false;
      this.errorMessage = <any>error;
     }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/email/email-sent-to/email-sent-to.component.ts